export const ClientBookingClassesLocations = {
  en: {
    'Select location': 'Select location',
  },
  uk: {
    'Select location': 'Оберіть локацію',
  },
};
